import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema } from "./validation.ts";


export type FDWDoiSendMailResponse = string;

export class FDWDoiSendMail extends Request<FDWDoiSendMailResponse>{
    method : TRequestMethod = "POST";
	responseSchema : Schema = 'string';

    constructor (
        public session_id: string,
        public email: string){
        super();
    }

    route() : string{
        return `${BASEURL}/fdw_doi_sendmail/`;
    }
}